import { useEffect, useState } from 'react';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';

interface ISignOutResult {
  SignedOut?: boolean;
  RedirectTo?: string;
}

/**
 * Replaces logout.aspx: clears session then returns to the fair home URL.
 */
const LogoutPage = () => {
  const [message, setMessage] = useState('Closing user account...');

  useEffect(() => {
    store.server
      .postApi<ServerResponse<ISignOutResult>>('../Person/SignOut', {})
      .then((x) => {
        if (x.Success) {
          const redirect = x.Value?.RedirectTo;
          if (redirect) {
            window.location.href = redirect;
            return;
          }
        }
        // Fallback: root of site
        setMessage('Signed out.');
        window.location.href = '../';
      })
      .catch(() => {
        setMessage('Signed out.');
        window.location.href = '../';
      });
  }, []);

  return (
    <div className="main-body-page grow text-center" data-testid="logout-page">
      <p data-testid="logout-message">{message}</p>
    </div>
  );
};

export default LogoutPage;
